import type { StoreApi } from 'zustand'

import type { GroupsStoreValuesType } from '@/features/groups/stores/groups/groups.store'
import { INITIAL_MENTORSHIP_GROUPS_STORE_VALUES } from '@/features/groups/stores/groups/groups.store'

export function setSelectedGroupIdAction(
  get: StoreApi<GroupsStoreValuesType>['getState'],
  set: StoreApi<GroupsStoreValuesType>['setState'],
  groupId: string | null,
) {
  set({ selectedGroupId: groupId })
}

export function setTempSelectedGroupIdAction(
  get: StoreApi<GroupsStoreValuesType>['getState'],
  set: StoreApi<GroupsStoreValuesType>['setState'],
  groupId: string | null,
) {
  set({ tempSelectedGroupId: groupId })
}

export function setTempSelectedObjectiveIdAction(
  get: StoreApi<GroupsStoreValuesType>['getState'],
  set: StoreApi<GroupsStoreValuesType>['setState'],
  objectiveId: string | null,
) {
  set({ tempSelectedObjectiveId: objectiveId })
}

export function resetGroupsStoreAction(set: StoreApi<GroupsStoreValuesType>['setState']) {
  set(INITIAL_MENTORSHIP_GROUPS_STORE_VALUES)
}
